import {
  AUTH_EVENTS,
  AUTH_EVENT_PARAM,
  AUTH_BASE_PATH,
  isSupportedSocialLoginProvider,
  SOCIAL_LOGIN_PROVIDERS,
  AuthError,
} from '@move-auth/shared';
import * as errors from '@move-auth/shared/lib/errors';

import WebClient from './authClient';

let webClient;

export { AUTH_EVENTS, AUTH_EVENT_PARAM };

export const init = ({
  basePath,
  rootPath,
  locale,
  logger,
  onAuth,
  onAuthError,
  onAutoLogin,
  onAutoLoginError,
  user,
  checkInterval,
  forceAuthentication,
  horizontalUserSigninEnabled,
  horizontalTrustedTokenUrl,
}) => {
  webClient = new WebClient({
    basePath,
    rootPath,
    locale,
    logger,
    onAuth,
    onAuthError,
    onAutoLogin,
    onAutoLoginError,
    user,
    checkInterval,
    forceAuthentication,
    horizontalUserSigninEnabled,
    horizontalTrustedTokenUrl,
  });

  return webClient;
};

const checkLoginStatus = async () => webClient.start();

const login = (params = {}, sourceUrl = null) => {
  webClient.login(params, sourceUrl);
  return Promise.resolve();
};

const socialLogin = (provider, params, sourceUrl) => {
  if (isSupportedSocialLoginProvider(provider) === false) {
    throw new AuthError(
      `Social login provider "${provider}" not supported! Must be one of [${Object.values(
        SOCIAL_LOGIN_PROVIDERS
      ).join(', ')}]`
    );
  }
  webClient.login({ ...params, provider }, sourceUrl);
  return Promise.resolve();
};

const logout = (fragment, sourceUrl = null) => {
  webClient.logout(fragment, sourceUrl);
  return Promise.resolve();
};

const leave = (sourceUrl = null) => {
  webClient.leave(sourceUrl);
  return Promise.resolve();
};

const register = (params = {}, sourceUrl = null) => {
  webClient.register(params, sourceUrl);
  return Promise.resolve();
};

const isTokenActive = () => webClient.isTokenActive();

const isLoggedIn = () => webClient.isLoggedIn();

const refresh = ({ forceAuthentication } = {}) =>
  webClient.debouncedRefresh({ forceAuthentication });

export {
  checkLoginStatus,
  login,
  socialLogin,
  logout,
  leave,
  register,
  refresh,
  isTokenActive,
  isLoggedIn,
  errors,
  AUTH_BASE_PATH,
  SOCIAL_LOGIN_PROVIDERS,
};
